var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Doughnut',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":"AdminDoughnut","width":300,"height":300}})}
var staticRenderFns = []

export { render, staticRenderFns }